import { IMenuItem } from '.';
import { mainMenuTypes } from './menu.enum';

export const menuExtras: IMenuItem[] = [
    {
        id: mainMenuTypes.MyProfile,
        name: 'MY_PROFILE',
        linkChunk: 'profile',
        link: '/profile',
        matchedLabel: '',
        requiresPermission: false,
        isParent: true,
        component: 'ProfilePage',
        children: [
            {
                id: mainMenuTypes.TestMfa,
                name: 'TEST_PAGE_HEADER',
                matchedLabel: '',
                component: 'TestMfa',
                requiresPermission: false,
                linkChunk: 'testmfa',
                link: '/testmfa',
                parentId: mainMenuTypes.MyProfile,
            },
        ],
    },
];
